import useSelector from '@src/hooks/useSelector';

export default function useChatMessage(messageId: string | number | undefined | null) {
    return useSelector(state => {
        if (!messageId) {
            return null;
        }

        for (const chat of state.chats.chats) {
            const index = chat.messages.messageIdToPositionIndex[messageId] ?? null;
            if (index != null) {
                return chat.messages.pages[index.page]?.messages?.[index.index] ?? null;
            }
        }

        return null;
    });
}
